
import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import AcademicBackBtn from '../AcademicBackBtn';
const LabletProgram = ({ setShow, show }) => {
    const [lebletInfo, setLebletInfo] = useState(null);


    useEffect(() => {
        client
            .query({
                query: queries.lablet,
            })
            .then((response) => {
                const labletDoc = response.data.allLablet_programs.edges[0].node;
                setLebletInfo(labletDoc);
                window.scrollTo(0, 0)


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <>

            <section style={{ backgroundImage: 'url(' + lebletInfo?.section_bg?.url + ')' }} className=" pattern innovation-pattern ">
                <div className="container">
                <AcademicBackBtn/>

                    <h3 className="subtitle pt-0 pb-1">{lebletInfo?.title}</h3>
                    <p className="pt-2  body-text">{lebletInfo?.description} <br /></p>
                    <h5 className="appication-title">{lebletInfo?.recent_offer_title}</h5>
                    <ul className="ps-2  pt-2">
                        {lebletInfo?.offer_list?.map((offer, index) =>
                            <li
                                className="body-text list-unstyled"
                                key={index + 1}
                            >
                                 {offer.offer_info.split("-")[0]} -
                                <a
                                    target="_blank"
                                    href={offer.link}
                                    className="secondary-text fw-bold text-decoration-none"
                                > {offer.offer_info.split("-")[1]}
                                </a>
                            </li>)}

                    </ul>



                    <div className=" pt-2">
                        <h5 className="appication-title">{lebletInfo?.course_title}</h5>

                        <ul className="ps-4">
                            {lebletInfo?.course_list?.map((listInfo, index) => <li className="body-text" key={index + 1}>{listInfo.info}</li>)}

                        </ul>

                        <ul>
                            {lebletInfo?.description_list?.map((listInfo, index) => <li className="body-text" key={index + 1}>{lebletInfo.info[0]?.text}</li>)}

                        </ul>

                    </div>



                    <h5 className="appication-title pt-3">{lebletInfo?.criteria_text}</h5>
                    <p className="pb-1 body-text">{lebletInfo?.criteria_des}</p>


                    <h5 className="appication-title">{lebletInfo?.work_title}</h5>
                    <p className="pb-1 body-text">{lebletInfo?.work_description}</p>


                    <h5 className="appication-title">{lebletInfo?.content_title}</h5>
                    <p className=" body-text">{lebletInfo?.content_des}</p>
                    <ul className="ps-4 pb-1">
                        {lebletInfo?.content_list?.map((listInfo, index) => <li className="body-text" key={index + 1}>{listInfo.content_info}</li>)}

                    </ul>


                    <h5 className="appication-title">{lebletInfo?.application_title}</h5>
                    <p
                        className="pb-1 body-text"
                    >{lebletInfo?.applicationDes.slice(0, 267)}
                        <a
                        className="secondary-text fw-bold text-decoration-none"
                            href={"mailto:" + lebletInfo?.applicationDes.slice(267, 500)}>{lebletInfo?.applicationDes.slice(267, 500)}</a>

                    </p>






                </div>
            </section>


        </>


    );
};

export default LabletProgram;




